import { useEffect } from 'react';
import { Navigate, Outlet, useParams } from 'react-router-dom';
import { StatusBlock } from '@slims/ui/molecules';
import { useAdminScopeTree } from '@/hooks/use-admin-scope';
import { adminScopeFor } from '@/lib/admin-scope';
import { useAdminScopeStore } from '@/stores/admin-scope-store';
import { useAuthStore } from '@/stores/auth-store';

/** Only administrators of this CER (or the platform) may open its editor. */
export default function CerLayout() {
	const { id } = useParams<{ id: string }>();
	const { role, availableOrgs, loaded } = useAuthStore();
	const { tree: adminTree } = useAdminScopeTree();
	const setScope = useAdminScopeStore((s) => s.setScope);

	// La CER aperta diventa la CER di lavoro di tutta l'area admin (INB-331):
	// passando a Configurazioni o Soci si resta su questa, da qualunque punto la
	// si sia aperta (elenco CER, tabella superadmin, link diretto).
	useEffect(() => {
		if (!id) return;
		const current = useAdminScopeStore.getState();
		const next = adminScopeFor(adminTree, id, current.configId);
		if (next && (next.cerId !== current.cerId || next.configId !== current.configId))
			setScope(next.cerId, next.configId);
	}, [id, adminTree, setScope]);

	if (!loaded) return <StatusBlock kind="loading" message="Caricamento CER…" />;
	if (
		!id ||
		(role !== 'superadmin' && !availableOrgs.some((org) => org.id === id && org.role === 'admin'))
	)
		return <Navigate to="/dashboard" replace />;
	return <Outlet />;
}
